import iziToast from 'izitoast';

type ToastPosition = 'center' | 'bottomRight' | 'bottomLeft' | 'topRight' | 'topLeft' | 'topCenter' | 'bottomCenter';

export async function toastSuccess(options: { title?: string; message: string; position?: ToastPosition; class?: string; timeout?: number; overlay?: boolean }) {
  iziToast.success({
    title: options.title ?? 'Sucesso',
    message: options.message,
    position: options.position ?? 'center',
    class: options.class ?? 'izi-center-force success-style',
    timeout: options.timeout ?? 5000,
    overlay: options.overlay ?? false,
  });
}

export async function toastError(options: { title?: string; message: string; position?: ToastPosition; class?: string; timeout?: number; overlay?: boolean }) {
  iziToast.error({
    title: options.title ?? 'Erro',
    message: options.message,
    position: options.position ?? 'center',
    class: options.class ?? 'izi-center-force error-style',
    timeout: options.timeout ?? 5000,
    overlay: options.overlay ?? false,
  });
}

export async function toastInfo(options: { title?: string; message: string; position?: ToastPosition; class?: string; timeout?: number; overlay?: boolean }) {
  iziToast.info({
    title: options.title ?? 'Info',
    message: options.message,
    position: options.position ?? 'center',
    class: options.class ?? 'izi-center-force info-style',
    timeout: options.timeout ?? 5000,
    overlay: options.overlay ?? false,
  });
}

export async function toastWarning(options: { title?: string; message: string; position?: ToastPosition; class?: string; timeout?: number; overlay?: boolean }) {
  iziToast.warning({
    title: options.title ?? 'Atenção',
    message: options.message,
    position: options.position ?? 'center',
    class: options.class ?? 'izi-center-force warning-style',
    timeout: options.timeout ?? 5000,
    overlay: options.overlay ?? false,
  });
}

export async function toast(options: { type?: 'success' | 'error' | 'info' | 'warning'; title?: string; message: string; position?: ToastPosition; class?: string; timeout?: number; overlay?: boolean }) {
  const type = options.type ?? 'info';
  const base = {
    title: options.title,
    message: options.message,
    position: options.position ?? 'center',
    class: options.class,
    timeout: options.timeout ?? 5000,
    overlay: options.overlay ?? false,
  } as Record<string, unknown>;
  switch (type) {
    case 'success':
      iziToast.success({ ...base, class: base.class ?? 'izi-center-force success-style' });
      break;
    case 'error':
      iziToast.error({ ...base, class: base.class ?? 'izi-center-force error-style' });
      break;
    case 'warning':
      iziToast.warning({ ...base, class: base.class ?? 'izi-center-force warning-style' });
      break;
    default:
      iziToast.info({ ...base, class: base.class ?? 'izi-center-force info-style' });
  }
}
